import styled from 'styled-components';

export const ExtendedIconsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  margin: 16px 0;
  gap: 8px;

  img {
    height: 24px;
    width: 36px;
    border: 0.9px solid #000;
    border-radius: 2px;
    object-fit: cover;
  }
`;
